export default __webpack_public_path__ + "static/media/newWebmailCloud.c4de9d05.svg";